
import './App.css';
import Dashboard from './components/Dashboard/dashboard';
import {BrowserRouter, Switch, Route } from "react-router-dom";
import Materi from './components/Materi/Materi';
import KIKD from './components/Imagecard/KIKD';
import Informasi from './components/Imagecard/Informasi';
import NotFound from './views/Errors/NotFound';
import DashboardGuru from './components/Guru/DashboardGuru';
// import Kuis1 from './components/Materi/Pages/Pertidaksamaan/Kuis/Kuis'
import Footer from './components/Footer/Footer';
import Petunjuk from './components/Imagecard/Petunjuk/Petunjuk';
import Pretest from './components/Pretest/Pretest'
// import TableKuis1 from './components/Guru/Kuis1/TableKuis1';
// import TableKuis2 from './components/Guru/Kuis2/TableKuis2';

function App() {
  return (
    <div >
      
        <BrowserRouter>
          <Switch>
            <Route exact path="/">
              <div className="App">
            <Dashboard />
            <div>
            <Footer />
            </div>
              </div>
            </Route>
      
            <Route path="/materi" >
              <Materi />
            </Route>
            <Route path="/kidankd" >
              <KIKD />
            </Route>
            <Route path="/informasimedia" >
              <Informasi />
            </Route>
            <Route path="/petunjukapp" >
              <Petunjuk />
            </Route>
            <Route path="/guru">
              <DashboardGuru />
            </Route>
            <Route path="/pretest">
              <Pretest />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
            {/* <Route  path="/guru/kuis1"><TableKuis1 /></Route>
						<Route path="/guru/kuis2"><TableKuis2 /></Route> */}
          </Switch>
        </BrowserRouter>
        
    </div>
  );
}

export default App;
